export default __webpack_public_path__ + "static/media/cryptogamba.0f2bbe59.svg";